/**
 * Most price values are returned from the Graph in Decimal format (ex: 15.50).
 * However, some prices are returned in Cent format (ex: 1550) such as the bestPrice.
 *
 * cent prices must be converted to decimal format in order to be consistent on the FE
 */ const convertCentToDecimal = (serverCentAmount)=>{
    return serverCentAmount ? serverCentAmount / 100 : undefined;
};

export { convertCentToDecimal };
//# sourceMappingURL=convert-cent-to-decimal.js.map
